{
  "activate_for_visible": "Activate to make page visible online",
  "activate_to_publish": "Activate to show this job on career page",
  "auto_reply_enabled_description": "Automatically email candidates when they apply",
  "auto_reply_enabled_title": "Send confirmation email",
  "auto_reply_title": "Application confirmation",
  "background_color": "Background color",
  "button_color": "Button color",
  "career_page": "Career page",
  "choose_page": "Choose page",
  "confirmation_delete": "Do you want delete this career page?",
  "create_modal_title": "Create new career page",
  "create_page": "Create page",
  "optional_short_description": "Optional short description of your company HR politics and values",
  "page_deleted": "Page deleted",
  "page_title": "Page title",
  "publish_on_career_page": "Publish on career page",
  "sub_header": "Sub header",
  "update_modal_title": "Update career page",
  "update_page": "Update page",
  "~": "~"
}
